"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var validator = function textInputControlValidator(state, props) {
  var storedValue = state.storedValue;
  return new RegExp(props.fieldData.validation.pattern).test(storedValue);
};

var _default = validator;
exports["default"] = _default;